export default __webpack_public_path__ + "static/media/partner2.5b8ec76f.webp";